<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
        <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
      <d-button size="sm" class="btn-primary" @click.prevent="printSample()">
        <i class="fas fa-print"></i><span class="d-none d-lg-inline"> Imprimir</span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { catchPdf, openPdf } from '_utils';
import Events from '_utils/events';
import { _DELETE_SAMPLE_ } from '_modules/sample/components/SampleModel';
import SampleService from '_services/rest/modules/sample';

export default {
  name: 'sample-buttons',
  props: {
    sample: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_SAMPLE_, this.sample.id);
    },
    printSample() {
      this.setToggle({ type: 'progress', bool: true });
      SampleService.print(this.sample.id)
        .then(response => openPdf(response))
        .catch(error => this.activeAlert({ message: catchPdf(error.message), theme: 'danger' }))
        .finally(() => this.setToggle({ type: 'progress', bool: false }));
    },
  },
  mounted() {},
};
</script>
